// Carry Roll Fixable-priority — ranked correctable input deviations (emergent). Pure.
import { sensitivity } from './sensitivity';
import { findReference } from '../lib/referenceRanges';
import { radToDeg } from './units';
function edgeDeviation(value, band) {
    const [min, max] = band;
    if (value < min)
        return value - min; // negative: below band
    if (value > max)
        return value - max; // positive: above band
    return 0;
}
/**
 * Rank correctable input deviations (launch angle, spin) by expected carry gain.
 * Uses the reference band for the club/ball-speed and the finite-difference
 * sensitivities. Omits parameters with zero expected gain.
 */
export function fixablePriority(request) {
    const category = request.club?.category;
    const ballSpeedMs = request.launch.ballSpeed;
    const ref = category != null ? findReference(category, ballSpeedMs) : null;
    if (ref == null)
        return [];
    const sens = sensitivity(request);
    const sensByParam = new Map(sens.map((s) => [s.parameter, s]));
    const items = [];
    // Launch angle (deg)
    const launchDeg = radToDeg(request.launch.launchAngle);
    const launchDev = edgeDeviation(launchDeg, ref.launchAngleDeg);
    const launchSens = sensByParam.get('Launch angle');
    if (launchSens && launchDev !== 0) {
        const expectedGainM = Math.round(Math.abs(launchDev) * Math.abs(launchSens.dCarryPerUnit));
        if (expectedGainM > 0) {
            items.push({
                parameter: 'Launch angle',
                unit: '°',
                deviation: Math.round(launchDev * 10) / 10,
                dCarryPerUnit: launchSens.dCarryPerUnit,
                expectedGainM,
            });
        }
    }
    // Spin rate (rpm)
    const spinDev = edgeDeviation(request.launch.spinRpm, ref.spinRpm);
    const spinSens = sensByParam.get('Spin rate');
    if (spinSens && spinDev !== 0) {
        const expectedGainM = Math.round(Math.abs(spinDev) * Math.abs(spinSens.dCarryPerUnit));
        if (expectedGainM > 0) {
            items.push({
                parameter: 'Spin rate',
                unit: 'rpm',
                deviation: Math.round(spinDev),
                dCarryPerUnit: spinSens.dCarryPerUnit,
                expectedGainM,
            });
        }
    }
    items.sort((a, b) => b.expectedGainM - a.expectedGainM);
    return items;
}
//# sourceMappingURL=fixablePriority.js.map